
export function formatter(q, rules, step) {
  const currLayer = q.slice(-1)[0]
  const prevLayer = q.slice(-2)[0]

  let paths = []
  let nodes = []
  for (let i=1; i<prevLayer.data.length; i++) {
    const thisWindow = prevLayer.data.slice(i-1, i+2)
    const thisRule = thisWindow.join('')
    const currOutput = currLayer.data[i]

    const nextWindow = currLayer.data.slice(i-1, i+2)
    const nextRule = nextWindow.join('')
    const nextOutput = rules.get(nextRule)

    let neighboors = 0
    // place paths
    if ((thisRule.length === 3) && (currOutput === 1)) {
      for (let j=0; j<3; j++) {
        const v = thisWindow[j]
        if (v === 1) {
          if (j === 0) {
            neighboors += 1
            let rp = `m${step*(i-1)+step*0.5},${-step*0.5} l${step},${step}`
            paths.push(rp)
          }
          if (j === 1) {
            neighboors += 1
            let mp = `m${step*(i)+step*0.5},${-step*0.5} l${0},${step}`
            paths.push(mp)
          }
          if (j === 2) {
            neighboors += 1
            let lp = `m${step*(i+1)+step*0.5},${-step*0.5} l${-step},${step}`
            paths.push(lp)
          }
        }
      }
    }

    // decide to place terminal nodes
    if ((nextRule.length === 3) // ensure no nodes appear on edges of viz
        && (nextOutput === 0)   // do not place a line on a continuing vertical segment
      && (neighboors === 1 ))   // place nodes on vertices with only one parent
      { 
        const node = {x: step * i + step * 0.5}
        nodes.push(node)
      }

  }
  return {nodes: nodes, paths: paths}
}

export function* automata(rule, seedRow, nRows, nCols) {

  // const rule = new Map([
  //                       ['111', 1]
  //                     , ['110', 0]
  //                     , ['101', 0]
  //                     , ['100', 1]
  //                     , ['011', 0]
  //                     , ['010', 1]
  //                     , ['001', 1]
  //                     , ['000', 0]
  //                     ])

  // const seedRow = [0,0,0,0,0,1,0,0,0,0,0]
  // const nRows = 2
  // const nCols = seedRow.length

  // let a = automata(rule, seedRow, nRows, nCols)

  let prevRow = seedRow
  let currRow = []
  let ridx = 0
  while (true) {
    for (let cidx=1; cidx<nCols-1; cidx++) {
      if (cidx === 1) {
        currRow = [...new Array(nCols)].map(d => 0)
      }
      const prevState = prevRow.slice(cidx-1,cidx+2).join('')
      const currState = rule.get(prevState)
      currRow[cidx] = currState
    }
    ridx += 1
    prevRow = currRow
    yield {ridx: ridx, data: currRow, qpos: -1}
  }
}
